import { ReactElement } from 'react'

import { Cascader } from 'antd'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikCascaderProps<V> = FormikWithCustomHandlersProps<V>

function FormikCascader<V extends string[] = string[]>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikCascaderProps<V>): ReactElement {
    return (
        <Cascader
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikCascader)
